import { createFileRoute } from '@tanstack/react-router';
import FolderCreate from '~/containers/FolderCreate';

export const Route = createFileRoute('/documents/$folderId/newFolder')({
  component: FolderCreate,
  validateSearch(search): { from?: string } {
    return {
      from: (search.from as string) || undefined,
    };
  },
});
